/** Paleta profesional por tipo de organización hospitalaria. */
export const ORG_BRAND: Record<string, { primary: string; accent: string; emoji: string; label: string }> = {
  'hospital-privado': { primary: '#16a34a', accent: '#15803d', emoji: '🏥', label: 'Hospital privado' },
  'hospital-nacional': { primary: '#16a34a', accent: '#15803d', emoji: '🏨', label: 'Hospital nacional' },
};

export function orgBrand(orgTipo: string | null | undefined) {
  if (orgTipo && ORG_BRAND[orgTipo]) return ORG_BRAND[orgTipo];
  return ORG_BRAND['hospital-privado'];
}

export function orgLabel(orgTipo: string | null | undefined): string {
  return orgBrand(orgTipo).label;
}

/** Iniciales para avatar cuando no hay logo propio (máx. 2 letras). */
export function clinicInitials(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  const w = words[0] ?? 'HO';
  return w.slice(0, 2).toUpperCase();
}
